import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { ExtraServicePupop } from "./ExtraServicePupop"
import { ExtraServiceEntity } from "../../../Objects/ExtraService/ExtraServiceEntity"
import { extraServiceMemory } from "../../../Objects/Memory/Memory"
import { useGetExtraService } from "../../../hooks/ExtraService/useGetExtraService"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const ExtraServicesPage: React.FC = () => {
  const { t } = useTranslation("list")

  const [enableServices, setEnableServices] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { handleGetExtraService } = useGetExtraService()

  const [extraService, setExtraService] = useState<ExtraServiceEntity | undefined>(undefined)

  useEffect(() => {
    handleGetExtraService(() => {})
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const promotion = extraServiceMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setExtraService(promotion)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setExtraService(undefined)

    setEnableServices(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  const handleCopyExtraService = () => {
    if (!extraService) {
      return
    }

    setExtraService(new ExtraServiceEntity({ ...extraService, id: -1, iconUrl: "" }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("label_extra_service_message_count")}
          messageEmpty={t("label_extra_service_message_empty")}
          nameFindSearch={t("label_extra_service_page_place_holder")}
          data={extraServiceMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetExtraService(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
        />
      </div>

      {enableServices && (
        <ExtraServicePupop
          extraService={extraService}
          title={extraService && extraService.id !== -1 ? t("extraService:title_popup_edite") : t("extraService:title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyExtraService}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="servicos-extras"
          title={t("dataImport:title", { target: t("dataImport:target_extra_services") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetExtraService(() => {})}
        />
      )}
    </>
  )
}
